import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "button-list" }
const _hoisted_3 = { class: "button-list__tabs" }
const _hoisted_4 = { class: "container-page big country-page" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "position-relative" }
const _hoisted_7 = { class: "list-of-summons-countries w-100" }
const _hoisted_8 = {
  key: 0,
  class: "mb-8"
}
const _hoisted_9 = ["onClick"]
const _hoisted_10 = { key: 0 }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "container-page big country-analytics" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ButtonComponent = _resolveComponent("ButtonComponent")!
  const _component_WorldHotIndicator = _resolveComponent("WorldHotIndicator")!
  const _component_MapSelectCountry = _resolveComponent("MapSelectCountry")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_HeaderBlock = _resolveComponent("HeaderBlock")!
  const _component_PresentationDownloadModal = _resolveComponent("PresentationDownloadModal")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.country)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("ul", _hoisted_3, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabMaps, (tab) => {
                return (_openBlock(), _createElementBlock("li", {
                  key: tab.id
                }, [
                  _createVNode(_component_ButtonComponent, {
                    mod: "grey",
                    class: _normalizeClass(['button-redesign--tabs-analytics', { active: _ctx.activeTabMapId === tab.id }]),
                    onClick: ($event: any) => (_ctx.selectTabMap(tab))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(tab.text), 1)
                    ]),
                    _: 2
                  }, 1032, ["class", "onClick"])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_4, [
            (_ctx.mapCreateStatuses[0] || _ctx.activeTabMapId === 1)
              ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_WorldHotIndicator),
                  _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                    _createElementVNode("h2", { class: "title title--h3 title--select-country" }, "Выберите страну")
                  ], -1)),
                  _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_MapSelectCountry, {
                      class: "map-select-country",
                      countries: _ctx.countries,
                      countryNames: _ctx.countryNames,
                      onSelectMapCountry: _cache[0] || (_cache[0] = ($event: any) => (_ctx.selectMapCountry($event)))
                    }, null, 8, ["countries", "countryNames"]),
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.activeTabMapId === 1)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createVNode(_component_Multiselect, {
                              placeholder: "Выберите страну...",
                              label: "text",
                              searchable: true,
                              modelValue: _ctx.country,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.country) = $event)),
                              valueProp: "id",
                              trackBy: "text",
                              noResultsText: "Ничего не найдено.",
                              noOptionsText: "Список пуст.",
                              options: _ctx.countries,
                              onSelect: _ctx.onCountryFilter
                            }, null, 8, ["modelValue", "options", "onSelect"])
                          ]))
                        : _createCommentVNode("", true),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listOfSummonsCountries, (summonCountryItem) => {
                        return (_openBlock(), _createElementBlock("button", {
                          key: summonCountryItem.id,
                          class: "btn-presentation",
                          onClick: ($event: any) => (_ctx.summonCountry(summonCountryItem.id))
                        }, _toDisplayString(summonCountryItem.name), 9, _hoisted_9))
                      }), 128))
                    ])
                  ])
                ], 512)), [
                  [_vShow, _ctx.activeTabMapId === 1]
                ])
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.secondaryMapTabs, (tab) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: tab.id
              }, [
                (_ctx.mapCreateStatuses[tab.id - 1] || _ctx.activeTabMapId === tab.id)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(tab.is)))
                    ], 512)), [
                      [_vShow, _ctx.activeTabMapId === tab.id]
                    ])
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.country)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createVNode(_component_HeaderBlock, {
            selectOptions: _ctx.countries,
            countryExternal: _ctx.country,
            headerSelectTitle: "Страна",
            tabData: _ctx.tabData,
            tabDataTwo: _ctx.tabDataTwo,
            tabDataFour: _ctx.tabDataFour,
            isUnfriendlyCountry: _ctx.isUnfriendlyCountry,
            activeTab: _ctx.activeTab,
            activeTabId: _ctx.activeTabId,
            selectTypeTab: _ctx.selectTypeTab,
            onChangeCountry: _ctx.changeCountry,
            onOnOpenPresentationDialog: _ctx.onOpenPresentationDialog,
            onSwitchTab: _ctx.setActiveTypeTab,
            onSwitchTabLVLTwo: _ctx.selectTab
          }, null, 8, ["selectOptions", "countryExternal", "tabData", "tabDataTwo", "tabDataFour", "isUnfriendlyCountry", "activeTab", "activeTabId", "selectTypeTab", "onChangeCountry", "onOnOpenPresentationDialog", "onSwitchTab", "onSwitchTabLVLTwo"]),
          _createElementVNode("div", _hoisted_12, [
            (_ctx.currentTab)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: _normalizeClass(["analytics-tab", _ctx.currentTab.class])
                }, [
                  (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentTab.is), _normalizeProps(_guardReactiveProps(_ctx.currentTab.props)), null, 16))
                ], 2))
              : _createCommentVNode("", true)
          ])
        ]))
      : _createCommentVNode("", true),
    _createVNode(_component_PresentationDownloadModal, {
      modelValue: _ctx.presentation.dialogState,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.presentation.dialogState) = $event)),
      countries: _ctx.countries,
      defaultCountryId: _ctx.presentationDefaultCountryId
    }, null, 8, ["modelValue", "countries", "defaultCountryId"])
  ], 64))
}